import tableSort from './table_sort.reducer';

export default tableSort;


// WEBPACK FOOTER //
// src/main/components/tableSort/store/reducers/index.js